var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBanner = function SvgBanner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 97,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.33 84.872 16.875 96.98 0 84.872V.118h35.33v84.754Z",
    fill: "url(#banner_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "banner_svg__a",
    x1: 17.665,
    y1: 0.118,
    x2: 17.665,
    y2: 96.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2882E"
  })))));
};
export default SvgBanner;